export const ACCESS_TIERS = {
  AUTHENTICATED: 'authenticated',
  CORE: 'core',
  RESEARCH: 'research',
};

export const ACCESS_PRESENTATIONS = {
  DASHBOARD: 'dashboard',
  FEATURE: 'feature',
};

export const ACCESS_POLICY_IDS = {
  OPERATING_KPI_DASHBOARD: 'operating-kpi-dashboard',
  HIRING_DASHBOARD: 'hiring-dashboard',
  DEVELOPER_DASHBOARD: 'developer-dashboard',
  SECURITY_ANALYSIS_DASHBOARD: 'security-analysis-dashboard',
  AI_TRACKING_DASHBOARD: 'ai-tracking-dashboard',
  DAILY_HIRING_DASHBOARD: 'daily-hiring-dashboard',
  DAILY_DEVELOPER_DASHBOARD: 'daily-developer-dashboard',
  DEVELOPER_VERSIONS_DASHBOARD: 'developer-versions-dashboard',
  ADOPTION_EVENT_ADJUSTMENT: 'adoption-event-adjustment',
  GUIDANCE_DASHBOARD: 'guidance-dashboard',
  FILING_ANALYTICS_DASHBOARD: 'filing-analytics-dashboard',
  PARTNER_TRENDS_DASHBOARD: 'partner-trends-dashboard',
  HIRING_DETAIL_MAPPING: 'hiring-detail-mapping',
  CORE_FEATURE: 'core-feature',
  RESEARCH_DOWNLOAD: 'research-download',
};

const policy = (requiredTier, presentation) => ({ requiredTier, presentation });

export const ACCESS_POLICIES = {
  [ACCESS_POLICY_IDS.OPERATING_KPI_DASHBOARD]: policy(ACCESS_TIERS.CORE, ACCESS_PRESENTATIONS.DASHBOARD),
  [ACCESS_POLICY_IDS.HIRING_DASHBOARD]: policy(ACCESS_TIERS.CORE, ACCESS_PRESENTATIONS.DASHBOARD),
  [ACCESS_POLICY_IDS.DEVELOPER_DASHBOARD]: policy(ACCESS_TIERS.CORE, ACCESS_PRESENTATIONS.DASHBOARD),
  [ACCESS_POLICY_IDS.SECURITY_ANALYSIS_DASHBOARD]: policy(ACCESS_TIERS.CORE, ACCESS_PRESENTATIONS.DASHBOARD),
  [ACCESS_POLICY_IDS.AI_TRACKING_DASHBOARD]: policy(ACCESS_TIERS.CORE, ACCESS_PRESENTATIONS.DASHBOARD),
  [ACCESS_POLICY_IDS.DAILY_HIRING_DASHBOARD]: policy(ACCESS_TIERS.RESEARCH, ACCESS_PRESENTATIONS.DASHBOARD),
  [ACCESS_POLICY_IDS.DAILY_DEVELOPER_DASHBOARD]: policy(ACCESS_TIERS.RESEARCH, ACCESS_PRESENTATIONS.DASHBOARD),
  [ACCESS_POLICY_IDS.DEVELOPER_VERSIONS_DASHBOARD]: policy(ACCESS_TIERS.RESEARCH, ACCESS_PRESENTATIONS.DASHBOARD),
  [ACCESS_POLICY_IDS.ADOPTION_EVENT_ADJUSTMENT]: policy(ACCESS_TIERS.RESEARCH, ACCESS_PRESENTATIONS.FEATURE),
  [ACCESS_POLICY_IDS.GUIDANCE_DASHBOARD]: policy(ACCESS_TIERS.RESEARCH, ACCESS_PRESENTATIONS.DASHBOARD),
  [ACCESS_POLICY_IDS.FILING_ANALYTICS_DASHBOARD]: policy(ACCESS_TIERS.RESEARCH, ACCESS_PRESENTATIONS.DASHBOARD),
  [ACCESS_POLICY_IDS.PARTNER_TRENDS_DASHBOARD]: policy(ACCESS_TIERS.RESEARCH, ACCESS_PRESENTATIONS.DASHBOARD),
  [ACCESS_POLICY_IDS.HIRING_DETAIL_MAPPING]: policy(ACCESS_TIERS.RESEARCH, ACCESS_PRESENTATIONS.FEATURE),
  [ACCESS_POLICY_IDS.CORE_FEATURE]: policy(ACCESS_TIERS.CORE, ACCESS_PRESENTATIONS.FEATURE),
  [ACCESS_POLICY_IDS.RESEARCH_DOWNLOAD]: policy(ACCESS_TIERS.RESEARCH, ACCESS_PRESENTATIONS.FEATURE),
};

export const getAccessPolicy = (policyId, fallbackTier = ACCESS_TIERS.CORE) => (
  ACCESS_POLICIES[policyId] || policy(fallbackTier, ACCESS_PRESENTATIONS.DASHBOARD)
);

export const hasAccessForTier = ({
  requiredTier,
  isAuthenticated,
  hasCoreAccess,
  hasResearchAccess,
}) => {
  if (requiredTier === ACCESS_TIERS.RESEARCH) return Boolean(hasResearchAccess);
  if (requiredTier === ACCESS_TIERS.CORE) return Boolean(hasCoreAccess);
  return Boolean(isAuthenticated);
};

export const getAccessUpgradeCopy = (requiredTier, isAuthenticated) => {
  if (requiredTier === ACCESS_TIERS.RESEARCH) {
    return {
      title: 'Upgrade to SoftwareIQ Research Suite',
      ctaLabel: isAuthenticated ? 'Upgrade to Research' : 'Get Research Suite',
    };
  }
  return {
    title: 'Upgrade to SoftwareIQ Core',
    ctaLabel: isAuthenticated ? 'Upgrade to Core' : 'Start 7-day Trial',
  };
};
